// Generated by Melange

import SkeletonModuleCss from "./skeleton.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import Clsx from "clsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = SkeletonModuleCss;

function Skeleton(Props) {
  let className = Props.className;
  let style = Props.style;
  let tmp = {
    className: Clsx(className, css.root)
  };
  if (style !== undefined) {
    tmp.style = Caml_option.valFromOption(style);
  }
  return JsxRuntime.jsx("span", tmp);
}

const make = Skeleton;

export {
  make,
}
/* css Not a pure module */
